"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.list = void 0;
const create_fn_1 = require("../utils/create-fn");
const get_arg_1 = require("../utils/get-arg");
// NEW
const contains = (0, create_fn_1.createFn)("fn.list.contains", (args, context) => {
    const value = (0, get_arg_1.getArgArray)(args, 1, context);
    const piece = (0, get_arg_1.getArgUnknown)(args, 2, context);
    return value.some((item) => item == piece);
});
// NEW
const containsany = (0, create_fn_1.createFn)("fn.list.containsany", (args, context) => {
    const value = (0, get_arg_1.getArgArray)(args, 1, context);
    for (let i = 1; i <= args.length; i++) {
        const piece = (0, get_arg_1.getArgUnknown)(args, i, context);
        if (piece === undefined) {
            continue;
        }
        if (value.some((item) => item == piece)) {
            return true;
        }
    }
    return false;
});
exports.list = {
    contains,
    containsany,
};
//# sourceMappingURL=list.js.map